import i18next from "i18next";

function getProgramState(start: string, end: string) {
    const now = new Date();
    const startDate = new Date(start);
    const endDate = new Date(end);

    return {
        isStarted: now >= startDate,
        isFinished: now >= endDate,
        isRunning: now >= startDate && now < endDate,
    };
}


function formatDuration(diffMs: number): string {
    const totalMinutes = Math.ceil(diffMs / 60_000);

    const minutesInDay = 24 * 60;

    if (totalMinutes >= minutesInDay) {
        const days = Math.floor(totalMinutes / minutesInDay);
        const hours = Math.floor((totalMinutes % minutesInDay) / 60);
        return `${days}d ${hours}h`;
    }

    if (totalMinutes >= 60) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours}h ${minutes}m`;
    }

    return `${totalMinutes} ${i18next.t("Details.minutes")}`;
}


function getProgramStatus(start: string, end: string): string {
    const now = new Date();
    const startDate = new Date(start);
    const endDate = new Date(end);

    if (now >= endDate) {
        return `${i18next.t("Details.finished")}`;
    }

    if (now < startDate) {
        const diffMs = startDate.getTime() - now.getTime();
        return `${i18next.t("Details.will_start")}:  ${formatDuration(diffMs)}`;
    }

    const diffMs = endDate.getTime() - now.getTime();
    return `${i18next.t("Details.remaining_time")}: ${formatDuration(diffMs)}`;
}


export {getProgramStatus, getProgramState, formatDuration}
